// External libraries
import React from 'react';

// Internal modules
import { buildMPPUrl, getContent } from '@/lib';
import { Link } from '@/components/Common/';
import { logPayLaterLearnMoreClickedToFpti } from '../fpti';

interface GetPayLaterHeaderContentReturn {
  header: string;
  subheader: JSX.Element;
}

export const getPayLaterHeaderContent = (
  hasBNPLAltText?: boolean,
): GetPayLaterHeaderContentReturn => {
  const headerContent = hasBNPLAltText
    ? 'bnpl.payLater.headerAlt'
    : 'bnpl.payLater.header';

  const subHeaderContent = hasBNPLAltText
    ? 'bnpl.payLater.subheaderAlt'
    : 'bnpl.payLater.subheader';

  return {
    header: getContent(headerContent),
    subheader: (
      <>
        {getContent(subHeaderContent)}
        {!hasBNPLAltText && (
          <Link
            onClick={logPayLaterLearnMoreClickedToFpti}
            href={buildMPPUrl({
              mppPath: 'paylaterterms',
            })}
            text={getContent('base.learnMore')}
          />
        )}
      </>
    ),
  };
};
